export default "__VITE_ASSET__C2f7VWjM__"